export default "<ion-nav [root]=\"rootPage\" [rootParams]=\"rootParams\"></ion-nav>\r\n";